exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".xcAO8{position:relative;background-color:#fff;padding:2px 10px 0;min-height:240px;z-index:1;-webkit-box-shadow:0 2px 8px rgba(0,0,0,.04);box-shadow:0 2px 8px rgba(0,0,0,.04);border-radius:2px;-webkit-transition:all .1s ease-out;-o-transition:all .1s ease-out;transition:all .1s ease-out;font-weight:400;margin-bottom:20px}._1d9bv{padding:0!important}._2tFfJ{width:290px;padding:0 5px}._3_M_0{padding-bottom:0}._1prcS{position:relative;margin-bottom:3px;padding-top:7px;padding-bottom:10px;border-bottom:1px solid #e0e0e0;padding-right:90px}.jUsJd{position:absolute;right:0;top:10px}._27vpz{position:relative;font-size:15px;text-decoration:none;font-weight:700;color:#000;margin-bottom:3px;display:inline-block}.jSZTh{padding-bottom:2px;font-size:13px}._1W4CN{position:relative;font-size:13px;line-height:44px;color:#000}", ""]);

// exports
exports.locals = {
	"root": "xcAO8",
	"advertThumbItem": "_1d9bv",
	"advertItem": "_2tFfJ",
	"carouselBody": "_3_M_0",
	"head": "_1prcS",
	"logo": "jUsJd",
	"title": "_27vpz",
	"adr": "jSZTh",
	"count": "_1W4CN"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/components/TopAvtosalon/TopAvtosalon.css
// module id = 2439
// module chunks = 0 33